// StaticHTMLPage.tsx
const StaticHTMLPage = ({ page }: { page: string }) => {
    return (
        <iframe
            src={`/old-site/${page}.html`}
            title={page}
            style={{ width: '100%', height: '100vh', border: 'none' }}
        />
    );
};

export default StaticHTMLPage;